import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const MEDICINE_GROUP_CORE_FIELDS = gql`
  fragment MedicineGroupCoreFields on MedicineGroup {
    id
    name
    scheduledTime
  }
`;

export const MEDICINE_GROUP_FIELDS = gql`
  ${MEDICINE_GROUP_CORE_FIELDS}
  fragment MedicineGroupFields on MedicineGroup {
    ...MedicineGroupCoreFields
    client { id, name }
    medicines { id, name, emoji }
  }
`;

export const MEDICINE_GROUP = gql`
  ${MEDICINE_GROUP_FIELDS}
  query MedicineGroup($id: ID!) {
    medicineGroup(id: $id) {
      ...MedicineGroupFields
    }
  }
`;

export const MEDICINE_GROUPS = gql`
  ${MEDICINE_GROUP_FIELDS}
  query MedicineGroups(
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    medicineGroups(
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...MedicineGroupFields
        }
      }
      totalCount
    }
  }
`;

export const CREATE_MEDICINE_GROUP = gql`
  ${MEDICINE_GROUP_CORE_FIELDS}
  mutation CreateMedicineGroup($input: CreateMedicineGroupInput!) {
    createMedicineGroup(input: $input) {
      medicineGroup {
        ...MedicineGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_MEDICINE_GROUP = gql`
  ${MEDICINE_GROUP_CORE_FIELDS}
  mutation UpdateMedicineGroup($input: UpdateMedicineGroupInput!) {
    updateMedicineGroup(input: $input) {
      medicineGroup {
        ...MedicineGroupCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const DESTROY_MEDICINE_GROUP = gql`
  mutation DestroyMedicineGroup($input: DestroyMedicineGroupInput!) {
    destroyMedicineGroup(input: $input) {
      ${ERRORS}
    }
  }
`;
